/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserRequestDto
 */
export interface UpdateUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    roleId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequestDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    language: UpdateUserRequestDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    name: string;
}


/**
 * @export
 */
export const UpdateUserRequestDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type UpdateUserRequestDtoLanguageEnum = typeof UpdateUserRequestDtoLanguageEnum[keyof typeof UpdateUserRequestDtoLanguageEnum];


/**
 * Check if a given object implements the UpdateUserRequestDto interface.
 */
export function instanceOfUpdateUserRequestDto(value: object): value is UpdateUserRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateUserRequestDtoFromJSON(json: any): UpdateUserRequestDto {
    return UpdateUserRequestDtoFromJSONTyped(json, false);
}

export function UpdateUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'roleId': json['roleId'],
        'active': json['active'],
        'language': json['language'],
        'name': json['name'],
    };
}

export function UpdateUserRequestDtoToJSON(json: any): UpdateUserRequestDto {
    return UpdateUserRequestDtoToJSONTyped(json, false);
}

export function UpdateUserRequestDtoToJSONTyped(value?: UpdateUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'roleId': value['roleId'],
        'active': value['active'],
        'language': value['language'],
        'name': value['name'],
    };
}

